module.exports = __webpack_public_path__ + "img/3-on.2eaa0e17.png";